import { Component } from '@angular/core';

@Component({
  selector: 'app-section-titulo-empreendedorismo-inovacao',
  templateUrl: './section-titulo-empreendedorismo-inovacao.component.html',
  styleUrls: ['./section-titulo-empreendedorismo-inovacao.component.scss'],
})
export class SectionTituloEmpreendedorismoInovacaoComponent {}
